import { AppConfig } from "../config/app.config";


export const environment: AppConfig = {
  apiUrl: 'https://dev-rcscorewebapi.redcurve.com/api/',
  environment: 'dev',
  retryAttempts: 3,
  isProd: false
};
